import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsCustomFieldsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-view',
	path: '/secure/admin/ViewCustomFields.jspa',
};
